import React, { useState, useMemo } from 'react';
import './Promotions.css';
import API_BASE_URL from "../../config/api";
import fallbackImg from "../../Components/Assets/pageHeaderImg/product_header.jpg";

const PROMO_BANNER_URL = 'https://bodyfriend.com.my/bodyfriend_backend/uploads/promo/banner/WEBSITE BANNER oct.jpg';  // 7月促销已结束，新banner来了再改

// ===== 产品数据（隐藏的产品用注释保留，方便将来启用） =====
const PRODUCTS = [
  // ============================================================
  // 暂时隐藏（有促销时启用）
  // ============================================================
   {
     sku: "BF-001",
     name: "Phantom Rovo",
     category: "Healthcare Robot",
     image: "https://bodyfriend.com.my/bodyfriend_backend/uploads/productImages/Website Sale Oct Promo-05.jpg",
     href: "/promotions/phantom-rovo",
     price: 32999,
     promoPrice: 32999,
     isNew: true,
     installmentPrice: "RM374.98*/month",
     npPrice: "RM32,999",
   },
   {
     sku: "BF-003",
     name: "Falcon S",
     category: "Healthcare Robot",
     image: "https://bodyfriend.com.my/bodyfriend_backend/uploads/productImages/Website Sale Oct Promo-04.jpg",
     href: "/promotions/falcon-s",
     price: 19999,
     promoPrice: 19999,
     isNew: false,
     installmentPrice: "RM249.98*/month",
     npPrice: "RM19,999",
   },
   {
     sku: "BF-006",
     name: "Quantum Audio Speakers by Bang & Olufsen",
     category: "Healthcare Robot",
     image: "https://bodyfriend.com.my/bodyfriend_backend/uploads/productImages/Website Sale Oct Promo-06.jpg",
     href: "/promotions/quantum",
     price: 47999,
     promoPrice: 47999,
     isNew: true,
     installmentPrice: "RM499.98*/month",
     npPrice: "RM47,999",
   },

  // ============================================================
  // 当前显示的产品（有促销）
  // ============================================================
  // ===== Eden（Massage Bed） =====
  {
    sku: "BF-002",
    name: "Eden",
    category: "Massage Bed",
    image: "https://bodyfriend.com.my/bodyfriend_backend/uploads/productImages/Website Sale Oct Promo-03.jpg",
    href: "/promotions/eden",
    price: 32999,
    promoPrice: 32999,
    isNew: false,
    installmentPrice: "RM374.98*/month",
    npPrice: "RM32,999",
  },
  // ===== Famille（Massage Sofa） =====
  {
    sku: "BF-004",
    name: "Famille",
    category: "Massage Sofa",
    image: "https://bodyfriend.com.my/bodyfriend_backend/uploads/productImages/Website Sale Oct Promo-01.jpg",
    href: "/promotions/famille",
    price: 10999,
    promoPrice: 10999,
    isNew: true,
    installmentPrice: "RM111.09*/month",
    npPrice: "RM10,999",
  },
// ============================================================
// Carna（Massage Chair）— 暂时隐藏
// 要恢复时，把下面的 /* 和 */ 删除即可
// ============================================================


{
  sku: "BF-005",
  name: "Carna",
  category: "Massage Chair",
  image: "https://bodyfriend.com.my/bodyfriend_backend/uploads/productImages/Website Sale Oct Promo-02.jpg",
  href: "/promotions/carna",
  price: 18999,
  promoPrice: 18999,
  isNew: false,
  installmentPrice: "RM277.75*/month",
  npPrice: "RM18,999",
},

  // ===== Massage Bed（新增产品，暂时隐藏） =====
  // {
  //   sku: "BF-007",
  //   name: "Massage Bed Pro",
  //   category: "Massage Bed",
  //   image: "https://bodyfriend.com.my/bodyfriend_backend/uploads/productImages/massage_bed_1.jpg",
  //   href: "/promotions/massage-bed-pro",
  //   price: 9999,
  //   promoPrice: 9999,
  //   isNew: true,
  //   installmentPrice: "RMxxx*/month",
  //   npPrice: "RMxx,xxx",
  // },
];

const Promotions = () => {
  // ✅ 把默认值从 "popularity" 改成 "price-low-high"
  const [sort, setSort] = useState("price-low-high");
  const [bannerFailed, setBannerFailed] = useState(false);

  const list = useMemo(() => {
    let arr = PRODUCTS;

    switch (sort) {
      case "name-asc":
        arr = [...arr].sort((a, b) => a.name.localeCompare(b.name));
        break;
      case "name-desc":
        arr = [...arr].sort((a, b) => b.name.localeCompare(a.name));
        break;
      case "new-first":
        arr = [...arr].sort((a, b) => Number(b.isNew) - Number(a.isNew));
        break;
      case "price-low-high":   // ✅ 价格从低到高
        arr = [...arr].sort((a, b) => a.price - b.price);
        break;
      default:
        break;
    }
    return arr;
  }, [sort]);

  return (
    <div className="promo-page">
      <div className="promo-banner">
        <img
          src={bannerFailed ? fallbackImg : `${PROMO_BANNER_URL}?v=${new Date().toDateString()}`}
          alt="Current Promotions"
          className="promo-banner-img"
          onError={() => setBannerFailed(true)}
        />
      </div>

      <div className="promo-wrapContent">
        <div className="promo-sort-section">
          <span>{list.length} cases</span>
          <select
            value={sort}
            onChange={(e) => setSort(e.target.value)}
            className="promo-sort-dropdown"
          >
            <option value="price-low-high">Price: Low to High</option>  {/* ✅ 移到第一位，默认显示 */}
            <option value="popularity">Sort by popularity</option>
            <option value="new-first">New First</option>
            <option value="name-asc">Name A–Z</option>
            <option value="name-desc">Name Z–A</option>
          </select>
        </div>

        <div className="promo-products-display">
          {list.map((p) => (
            <div key={p.sku} className="promo-product-card">
              <a href={p.href} className="promo-product-link">
                <img
                  src={p.image}
                  alt={p.name}
                  className="promo-product-image"
                  onError={(e) => {
                    e.target.src = 'https://via.placeholder.com/300x300?text=No+Image';
                  }}
                />
                <h2 className="promo-product-name">{p.name}</h2>
                <div className="promo-product-price">
                  <span className="promo-price-installment">{p.installmentPrice}</span>
                  <span className="promo-price-np">{p.npPrice}</span>
                </div>
              </a>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Promotions;